import { useTreeRoots } from "routes/schedule/lib/useTreeRoots"

export function TreeRoots() {
    useTreeRoots()
    return null
}
